import { Delete } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEYS = ["1","2","3","4","5","6","7","8","9","C","0","⌫"];

export function Keypad({ onKey, onClear, onBackspace, onSeparator }) {
  const press = (k) => {
    if (k === "C") return onClear?.();
    if (k === "⌫") return onBackspace?.();
    onKey?.(k);
  };
  return (
    <div className="grid grid-cols-3 gap-2" data-testid="pos-keypad">
      {KEYS.map((k) => (
        <button
          key={k}
          type="button"
          onClick={() => press(k)}
          data-testid={`pos-keypad-key-${k === "⌫" ? "backspace" : k === "C" ? "clear" : k}`}
          className={`h-14 md:h-16 rounded-xl border font-semibold text-xl font-mono tabular-nums active:scale-[0.99] ${
            k === "C" ? "bg-destructive/15 text-destructive border-destructive/30 hover:bg-destructive/25"
            : k === "⌫" ? "bg-secondary text-foreground border-border hover:bg-secondary/70"
            : "bg-[hsl(var(--pos-key))] text-[hsl(var(--pos-key-fg))] border-border hover:bg-[hsl(var(--pos-key-hover))]"
          }`}
        >
          {k === "⌫" ? <span className="inline-flex items-center justify-center w-full"><Delete size={20}/></span> : k}
        </button>
      ))}
      {onSeparator && (
        <button type="button" onClick={onSeparator} data-testid="pos-keypad-key-separator" title="Separador de lista (coma / espacio)"
          className="col-span-3 h-11 rounded-xl border border-border bg-secondary text-foreground font-semibold text-sm hover:bg-secondary/70 active:scale-[0.99]">
          , Separar número (multiselección)
        </button>
      )}
    </div>
  );
}

export default Keypad;
